module.exports = __webpack_public_path__ + "static/assets/495a2082d4dad08a209d3aa9f1252860.svg";